import  { useState } from "react";
import "../../pages/Home/HomePage.css";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";

const faqs = [
  {
    id: 1,
    title: "What technologies do you use for web development?",
    content:
      "We leverage a variety of technologies based on project requirements, including but not limited to HTML5, CSS3, JavaScript, and popular frameworks like React and Angular.",
  },
  {
    id: 2,
    title: "How do you ensure cross-device compatibility?",
    content:
      "We rigorously test our mobile apps on various devices to ensure cross-device compatibility. We follow responsive design principles and use frameworks that support multiple screen sizes.",
  },
  {
    id: 3,
    title: "How do you ensure website proper scalability?",
    content:
      "Our web development process includes planning for scalability from the beginning, utilizing scalable architectures and technologies to accommodate future growth.",
  },
  {
    id: 4,
    title: "Which digital marketing channels do you specialize in?",
    content:
      "We specialize in a range of digital marketing channels, including search engine optimization (SEO), social media marketing, content marketing, and email marketing.",
  },
  {
    id: 5,
    title: "Do you develop apps for both iOS and Android?",
    content:
      "Yes, we specialize in developing mobile applications for both iOS and Android platforms, as well as cross-platform solutions using technologies like React Native or Flutter.",
  },
  {
    id: 6,
    title: "How do you measure the success of digital marketing campaigns?",
    content:
      "We use key performance indicators (KPIs) such as website traffic, conversion rates, and engagement metrics to measure the success of digital marketing campaigns.",
  },
];

const Faqs = () => {
  const [expandedBoxIndex, setExpandedBoxIndex] = useState(null);

  const handleExpand = (index) => {
    setExpandedBoxIndex(expandedBoxIndex === index ? null : index);
  };

  return (
    <div className="faqs-section">
      <div className="container">
        <div className="faqs-header">
          <h1>FAQs</h1>
        </div>
        <div className="faqs-content">
          {faqs.map((faq, index) => (
            <div key={faq.id} className="dropdown">
              <div
                className="dropdown-header"
                onClick={() => handleExpand(index)}
              >
                <h4>{faq.title}</h4>
                {expandedBoxIndex === index ? (
                  <RiArrowUpSLine />
                ) : (
                  <RiArrowDownSLine />
                )}
              </div>
              {expandedBoxIndex === index && (
                <div className="dropdown-content">
                  <p>{faq.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
